"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Provider_1 = require("./Provider");
var idleTimer_1 = __importDefault(require("./idleTimer"));
var helpers_1 = require("./helpers");
var withAnalytics = function (_a) {
    var componentName = _a.componentName, enableComponentTracking = _a.enableComponentTracking, timerOptions = _a.timerOptions;
    return function (WrappedComponent) { var _a; return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.componentName = '';
                _this.componentDidMountTimestamp = 0;
                _this.sendMetrics = function () {
                    var configs = _this.context.analytics.configs;
                    var track = helpers_1.tracker(configs);
                    var average = (Date.now() - _this.componentDidMountTimestamp - _this.timer.idleTime) /
                        1000;
                    if (average > 1)
                        track('trackMetric', 'React Component Engaged Time (seconds)', {
                            appinsights: {
                                'Component Name': _this.componentName,
                                average: average
                            }
                        }, ['appinsights']);
                };
                return _this;
            }
            class_1.prototype.componentDidMount = function () {
                if (enableComponentTracking) {
                    this.componentName =
                        componentName || WrappedComponent.prototype.constructor.name;
                    this.timer = new idleTimer_1.default(timerOptions);
                    this.timer.start();
                    this.componentDidMountTimestamp = Date.now();
                    window.addEventListener('beforeunload', this.sendMetrics);
                }
            };
            class_1.prototype.componentWillUnmount = function () {
                if (enableComponentTracking) {
                    this.sendMetrics();
                    window.removeEventListener('beforeunload', this.sendMetrics);
                    this.timer.stop();
                    this.timer = null;
                }
            };
            class_1.prototype.render = function () {
                var _this = this;
                return (react_1.default.createElement(Provider_1.AnalyticsContext.Consumer, null, function (context) { return react_1.default.createElement(WrappedComponent, __assign({}, _this.props, context)); }));
            };
            return class_1;
        }(react_1.PureComponent)),
        _a.contextType = Provider_1.AnalyticsContext,
        _a; };
};
exports.default = withAnalytics;
